// extracted by mini-css-extract-plugin
export default {"cls1":"Zzj_L1ZWAJgZjI1cqOPM","cls2":"ENJaUtC4jKrSOk6YC5fZ Zzj_L1ZWAJgZjI1cqOPM","bookingAppRedesign":"TOSxqrjAZdjsNVbRGon2"};